import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNewspaper2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="newspaper-2, guide, info, faq, book"><path d="M12 7.75C12 6.09315 10.6569 4.75 9 4.75H1.75V19.25H9C11 19.25 12 20.3431 12 22M12 7.75C12 6.09315 13.3431 4.75 15 4.75H22.25V19.25H15C13 19.25 12 20.3431 12 22M12 7.75V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconNewspaper2;
